import { Privacy } from "@/components/privacy/Privacy";

export default Privacy;
